/* soft strip of the hall behind the top of a sub-page */
export default function PageBanner() {
  return (
    <div className="absolute inset-x-0 top-0 h-[420px] overflow-hidden pointer-events-none" aria-hidden="true">
      <img src="/assets/koselig-hero.jpg" alt="" className="w-full h-full object-cover object-[50%_20%] opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#05060f]/60 via-[#05060f]/80 to-[#05060f]" />
      <div className="grain absolute inset-0" />
    </div>
  );
}
